import {
    FormDatePicker,
    FormInputGroup,
    FormSection,
    FormText,
} from 'components/form';
import { useFieldArray } from 'react-hook-form';
import { VirtualDeviceInput } from 'types';

export function CreateDeviceModalDeliveries() {
    const { fields } = useFieldArray<VirtualDeviceInput>({
        name: 'fillups',
    });

    return (
        <FormSection title="Deliveries">
            <span>
                Add the last three deliveries for this account - we’ll use them
                to calculate fuel usage and accurately forecast the next
                delivery to make
            </span>
            {fields.map((field, index) => {
                return (
                    <FormInputGroup key={field.id}>
                        <FormText
                            field={`fillups.${index}.amount`}
                            label={`Delivery #${index + 1} Gallons`}
                            isNumber
                        />
                        <FormDatePicker
                            field={`fillups.${index}.time`}
                            label={`Delivery #${index + 1} Date`}
                        />
                    </FormInputGroup>
                );
            })}
        </FormSection>
    );
}
